class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    //this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onSummaryClick(event) {
    //console.log('onSummaryClick')
    const isOpen = this.mainDetailsToggle.hasAttribute("open");

    if (isOpen) {
      event.preventDefault(); 
    }

    isOpen
      ? this.close()
      : this.open();
  }

  open() {
    //console.log('open')
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.mainDetailsToggle.classList.add('active');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('opening');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('open');
      }, 250);
    }, 0);
  }

  close() {
    //console.log('close')
    this.mainDetailsToggle.classList.remove('open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('opening');
      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('active');
        setTimeout(() => {
          this.mainDetailsToggle.removeAttribute('open');
          this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        }, 0);
      }, 200);
    }, 100);
  }

  onFocusOut() {
    //console.log('focusOut')
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }
}

customElements.define('mega-menu', MegaMenu);